import React from "react";
import oscar from "../assets/1000011182.png";
import mamas from "../assets/1000011185.png";

export default function HomeHeader() {
    return (
        <div className="home-header">
            <div><img id="oscar-img" className="rocking-image" src={oscar} alt="Oscar" /></div>
            <h1>Welcome to the life of Tom and Sage</h1>
            <div><img id="mamas-img" className="rocking-image" src={mamas} alt="Mamas" /></div>
        </div>
    )
}